import * as React from 'react';
import { useSelector } from 'react-redux';

import { HeadCategories } from '../../components/HeadCategories';
import { ALL_PROMOS } from '../../constants/headCategories';
import { selectHeadCategories } from '../../selectors/promosPage';
import { IHeadCategory } from '../../types/promosPage';
import { trackClickCategories } from '../../utils/analytics';

export const HeadCategoriesContainer: React.FC = () => {
  const categories = useSelector(selectHeadCategories);

  const handleClick = React.useCallback((category: IHeadCategory) => {
    trackClickCategories({
      type: 'top_categories',
      searchConditions: category.queryString,
    });
  }, []);

  return <HeadCategories categories={categories} allPromos={ALL_PROMOS} onClick={handleClick} />;
};
